// eslint-disable-next-line no-unused-vars
/* global REDUX_DEVTOOLS */
import { compose } from 'redux';

// Use the Redux devtools composer if the extension exists
const enhance = window?.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
  ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({ name: 'builder-ui' })
  : compose;

async function getReduxConfig() {
  if (import.meta.env.REDUX_DEVTOOLS) {
    const Reactotron = await import('reactotron-react-js').then(
      module => module.default
    );
    const { reactotronRedux } = await import('reactotron-redux').then(
      module => module
    );
    const sagaPlugin = await import('reactotron-redux-saga').then(
      module => module.default
    );

    const reactotron = Reactotron.configure({
      name: 'builder-ui',
    })
      .use(reactotronRedux())
      .use(sagaPlugin())
      .connect();

    const sagaMonitor = reactotron.createSagaMonitor();

    return {
      composeEnhancers: enhancers =>
        enhance(enhancers, reactotron.createEnhancer()),
      sagaMonitor,
      logStateChange: (store, name) => {
        store.subscribe(() => {
          Reactotron.display({
            name: `${name} state updated`,
            value: store.getState(),
          });
        });
      },
    };
  }

  return {
    composeEnhancers: compose,
    sagaMonitor: undefined,
    logStateChange: () => {},
  };
}

export default getReduxConfig;
